import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import registerServiceWorker from './registerServiceWorker';
import { Provider } from "react-redux";
import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import { reducer as dbReducer } from "./db";
import pageReducer from "./pages/page-reducers";
import thunk from "redux-thunk";
import "./scss/main.scss";
import "./scss/global.scss";
import { canUseWorkers } from "exenv";
//import * as Sentry from "@sentry/browser";
import staticReducer from "./static-reducer";
import * as Sentry from '@sentry/react';

//
Sentry.init({
//     // dsn: 'https://key@server.com/foobar/1',
    dsn: 'http://e8a001d72f5a476a99851ecd39d44200:b9ae9b343c784c8e99c3396ad24cb30c@sentry.sharifin.com/10',
});

// Sentry.init({
//     dsn:
//         "http://e8a001d72f5a476a99851ecd39d44200:b9ae9b343c784c8e99c3396ad24cb30c@sentry.sharifin.com/10"
// });




const rootReducer = combineReducers({
    db: dbReducer,
    ui: pageReducer,
    statics: staticReducer
});

// eslint-disable-next-line
String.prototype.toPersianDigit = function(latinDigit) {
    return this.replace(/\d+/g, function(digit) {
        var enDigitArr = [],
            peDigitArr = [],
            i,
            j;
        for (i = 0; i < digit.length; i += 1) {
            enDigitArr.push(digit.charCodeAt(i));
        }
        for (j = 0; j < enDigitArr.length; j += 1) {
            peDigitArr.push(
                String.fromCharCode(
                    enDigitArr[j] +
                        (!!latinDigit && latinDigit === true ? 1584 : 1728)
                )
            );
        }
        return peDigitArr.join("");
    });
};

// eslint-disable-next-line
String.prototype.toEnglishDigit = function(persianDigit) {
    const persianNumbers = [
            /۰/g,
            /۱/g,
            /۲/g,
            /۳/g,
            /۴/g,
            /۵/g,
            /۶/g,
            /۷/g,
            /۸/g,
            /۹/g
        ],
        arabicNumbers = [
            /٠/g,
            /١/g,
            /٢/g,
            /٣/g,
            /٤/g,
            /٥/g,
            /٦/g,
            /٧/g,
            /٨/g,
            /٩/g
        ],
        fixNumbers = function(str) {
            if (typeof str === "string") {
                for (var i = 0; i < 10; i++) {
                    str = str
                        .replace(persianNumbers[i], i)
                        .replace(arabicNumbers[i], i);
                }
            }
            return str;
        };
    return fixNumbers(this);
};

String.prototype.trunc = function(n, useWordBoundary) {
    if (this.length <= n) {
        return this;
    }
    var subString = this.substr(0, n - 1);
    return (
        (useWordBoundary
            ? subString.substr(0, subString.lastIndexOf(" "))
            : subString) + "..."
    );
};

window.matchMedia =
    window.matchMedia ||
    function() {
        return {
            matches: false,
            addListener: function() {},
            removeListener: function() {}
        };
    };

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer,
    {},
    composeEnhancers(applyMiddleware(thunk))
);
const rootElement = document.getElementById("root");
ReactDOM.hydrate(
    <Provider store={store}>
        <App />
    </Provider>,
    rootElement
);

if (canUseWorkers) {
    // registerServiceWorker();
}

